var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 95,
    viewBox: "0 0 80 95",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3758 0H19.7599V17.084H51.3758V0Z",
    fill: "#1D0B77",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.856 8.54201H0V93.9621H42.9818C39.596 89.2791 37.6901 83.5454 37.5445 77.6044C37.399 71.6634 39.0213 65.8287 42.1731 60.9586C45.3248 56.0884 49.8395 52.4399 55.053 50.5496C60.2666 48.6593 65.9039 48.6271 71.1357 50.4577V8.54201H59.2797V25.626H11.856V8.54201Z",
    fill: "#1D0B77",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 88.9565L74.4119 95L63.2317 82.9173L52.0555 95L46.4674 88.9565L57.6436 76.8781L46.4674 64.7997L52.0555 58.7562L63.2317 70.8389L74.4119 58.7562L80 64.7997L68.8238 76.8781L80 88.9565Z",
    fill: "#1D0B77",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/noTasks.3eae678c32c59f653b7dfe3231ed3bfd.svg";
export { ForwardRef as ReactComponent };